import Cookies from 'js-cookie';
const COOKIE_NAME = 'appx_lang';
export const DEFAULT_LANGUAGE_CODE = 'en';
export const JAPANESE_LANGUAGE_CODE = 'ja';
const SUPPORTED_LANGUAGES = [DEFAULT_LANGUAGE_CODE, JAPANESE_LANGUAGE_CODE];
export function setLanguageInCookie(language) {
  Cookies.set(COOKIE_NAME, language);
}
export function getUserLanguage() {
  let currentLanguage = Cookies.get(COOKIE_NAME);
  if (currentLanguage === null) {
    // Gets browser locale from navigator. If browser has multiple languages only gets first.
    const userLocale = navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language;
    if (userLocale === JAPANESE_LANGUAGE_CODE) {
      currentLanguage = JAPANESE_LANGUAGE_CODE;
    }
  }
  if (!SUPPORTED_LANGUAGES.includes(currentLanguage)) {
    return DEFAULT_LANGUAGE_CODE;
  }
  return currentLanguage;
}